import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy } from 'react';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));

const TopActions = ({
  Styled,
  usDotManagement,
  i18n,
  options,
  filterSuccess,
  setPagination
}) => {
  const selectChange = (e) => {
    filterSuccess(e);
    setPagination(true);
  };

  return (
    <Styled.TopWrapper>
      <Styled.SearchWrapper>
        {layout === 'SpireonNew' ? null: <Search
          onChange={(e) => selectChange(e)}
          default={usDotManagement?.list}
          fromData
          placeHolder={i18n.t('usDotManagement.search')}
          query={[
            'dotNumber',
            'carrierName',
            'mainAddress',
            'state',
            'city',
            'zipCode'
          ]}
          id="usDotManagement"
        ></Search>}
      </Styled.SearchWrapper>
      {layout === 'OldUi' ? (
        <Styled.AddWrapper>
        <Button
          label={i18n.t('usDotManagement.addDot')}
          type={'submit'}
          onClick={() => {
            options('');
          }}
          className="AddButton"
        />
        </Styled.AddWrapper>
      ) : (
        <Icon
          src={mediaUrls?.addVehicle}
          primary
          onClick={() => options('')}
          tooltip={i18n.t('common.add')}
          className="AddButton"
        />
      )}
    </Styled.TopWrapper>
  );
};
export default TopActions;
